import { BaseControlOption } from '../control-options/control-option.interface';
import { UiControl } from './ui-control.model';

export class NumericControl extends UiControl<number | null> {

  decimals: number;
  format: string;

  constructor(id: string, label: string, value: number | null, numDecimals: number = 0, format: string = "n", ...options: BaseControlOption[]) {
    super(id, label, value, false, options);

    this.className = "NumericControl";
    this.decimals = numDecimals;
    this.format = format;
  }

}
